const Photography = () => {

    return (
      <div id="photography" className="container">
        <h1>Photography 🚧</h1>
      </div>
    );
  };
  
  export default Photography;